import classnames from 'classnames';
import { CKSlider, CKSliderProps } from 'clearkit';
import { useState } from 'react';

import {
  CreditOption,
  CreditSelectorLabel,
  CreditSelectorLabelGrid,
} from './CreditSelectorLabel';

type CreditSelectorProps = CKSliderProps & {
  options: CreditOption[];
  plan?: 'Growth';
};

export const CreditSelector: React.FC<CreditSelectorProps> = ({
  className,
  options,
  value,
  onChange,
  ...rest
}) => {
  const [activeIndex, setActiveIndex] = useState(
    options.findIndex((plan) => plan.credits === value),
  );

  const handleChange = (index: number) => {
    setActiveIndex(index);
    onChange?.(options[index].credits);
  };

  const lastOption = options.length - 1;

  return (
    <section className="space-y-6">
      <div>Choose the credit package that best fits your needs</div>
      <div className={classnames('px-4 pr-12 space-y-6', className)}>
        <CreditSelectorLabelGrid>
          {options.map((option, index) => (
            <CreditSelectorLabel
              activeIndex={activeIndex}
              index={index}
              key={option.credits}
              lastOption={lastOption}
              option={option}
            >
              {option.credits.toLocaleString('en-US')}
            </CreditSelectorLabel>
          ))}
        </CreditSelectorLabelGrid>
        <CKSlider
          {...rest}
          hasTooltip={false}
          max={lastOption}
          min={0}
          onChange={handleChange}
          step={1}
          value={activeIndex}
          variant="x"
        />
        <CreditSelectorLabelGrid>
          {options.map((option, index) => (
            <CreditSelectorLabel
              activeIndex={activeIndex}
              index={index}
              isOnlySelectedVisible
              key={option.cost}
              lastOption={lastOption}
              option={option}
            >
              {option.cost === 0
                ? 'Free'
                : `$${option.cost.toLocaleString()}/month`}
            </CreditSelectorLabel>
          ))}
        </CreditSelectorLabelGrid>
      </div>
    </section>
  );
};
